import { render } from "./NotFound.vue?vue&type=template&id=43ce6c42&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=43ce6c42&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ce6c42"]])

export default __exports__